import React, { FC } from 'react';
import { useFormikContext } from 'formik';

// Components
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import BlockWrapper from 'components/BlockWrapper';

// Types
import {
  WorkspaceBlockProps,
  WorkspaceSettingsNames as Names
} from 'routes/WorkspaceSettings/WorkspaceSettingsTypes';
import {
  AdminsOrAdminsPmOrAnyone,
  IWorkspaceSettingsPatch
} from 'types/workspaceSettings';

// Styles
import classes from './CreateProjects.module.scss';

const CreateProjects: FC<WorkspaceBlockProps> = ({ onChange }) => {
  const { values, handleChange } = useFormikContext<IWorkspaceSettingsPatch>();

  return (
    <BlockWrapper>
      <Box className={classes.wrapper}>
        <Box className={classes.wrapper}>
          <Box className={classes.textInfoContainer}>
            <span className={classes.title}>
              Who can create projects and clients
            </span>
            <span className={classes.description}>
              Allow people to create and manage new projects and clients.
            </span>
          </Box>
        </Box>
        <Box className={classes.FieldsContainer}>
          <Box className={classes.inputContainer}>
            <Box className={classes.row}>
              <RadioGroup
                row
                name={Names.canCreateProjectsClients}
                onChange={(e) => {
                  handleChange(e);
                  onChange();
                }}
                value={values.canCreateProjectsClients}
                defaultValue={values.canCreateProjectsClients}
              >
                <FormControlLabel
                  control={<Radio />}
                  value={AdminsOrAdminsPmOrAnyone.ADMINS}
                  label={
                    <Typography className={classes.font}>Admins</Typography>
                  }
                />
                <FormControlLabel
                  control={<Radio />}
                  value={AdminsOrAdminsPmOrAnyone.ADMINSMANAGER}
                  label={
                    <Typography className={classes.font}>
                      Admins and project managers
                    </Typography>
                  }
                />
                <FormControlLabel
                  control={<Radio />}
                  value={AdminsOrAdminsPmOrAnyone.ANYONE}
                  label={
                    <Typography className={classes.font}>Anyone</Typography>
                  }
                />
              </RadioGroup>
            </Box>
          </Box>
        </Box>
      </Box>
    </BlockWrapper>
  );
};

export default CreateProjects;
